import { useState, useEffect, useRef } from 'react';
import { HexColorPicker } from 'react-colorful';

interface ColorPickerProps {
  label: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}

export function ColorPicker({ label, value, onChange }: ColorPickerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [hexInput, setHexInput] = useState(value || '');
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setHexInput(value || '');
  }, [value]);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleHexChange = (hex: string) => {
    setHexInput(hex);
    if (hex.match(/^#[0-9A-Fa-f]{6}$/)) {
      onChange(hex);
    }
  };

  return (
    <div className="property-row color-row">
      <label>{label}</label>
      <div className="color-picker-wrapper" ref={popoverRef}>
        <button
          className="color-swatch"
          style={{ backgroundColor: value || 'transparent' }}
          onClick={() => setIsOpen(!isOpen)}
          title={value || 'No color'}
        >
          {!value && <span className="no-color-x">×</span>}
        </button>
        {isOpen && (
          <div className="color-popover">
            <HexColorPicker color={value || '#ffffff'} onChange={onChange} />
            <input
              type="text"
              className="hex-input"
              value={hexInput}
              placeholder="#000000"
              onChange={(e) => handleHexChange(e.target.value)}
            />
            <button className="clear-color-btn" onClick={() => { onChange(undefined); setIsOpen(false); }}>
              Clear (No Color)
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
